import React from "react";
import bg19 from "./../../../images/addmission/watermark.png";

function HousePentagon() {
  return (
    <div
      style={{
        backgroundImage: "url(" + bg19 + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "40%",
        backgroundPosition: "center",
        border: "1px solid black",
        padding: "10px",
      }}
    >
      <h5>THE HOUSE SYSTEM AT PENTAGON INTERNATIONAL COLLEGE</h5>
      <h6>1. Doctor John Garang de Mabior’s House.</h6>
      <p>
        The house picked up the name from the father of our nation who struggled
        for liberation of the oppressed and marginalized people of Sudan in
        general and South Sudan in particular. It has to model and mentor the
        members of the house to value unity and make it a desired goal by every
        member.
      </p>
      <h5>
        This house motto is: “TWO EYES CAN SEE ONE THING BUT THEY CANNOT SEE
        EACH OTHER”.
      </h5>
      <h6>2. Nelson Mandela House</h6>
      <p>
        “Deep down the bottom of human’s heart lies unconditional love and mercy
        for fellow being. If human being knows how to hate, he too knows how to
        adopt love and mercy for fellow being”. The great father of our
        continent, Nelson Mandela quoted. Members of this house must be mentored
        to believe in victory, struggle to co-exist side by side with one
        another and that what seems impossible is always possible when there is
        will.
      </p>
      <h5>The house motto is: “WE ARE THE CHAMPIONS”. </h5>
      <h6>4. Malala House </h6>
      <p>
        “One child one teacher, one book one pen can change the world”. Malala
        Yousatzai, is a Pakistan Activist, for female education and the youngest
        Nobel Laureate said. This house emphasizes the importance of girl child
        education.
      </p>
      <h5>The house motto: “CHANGE WE NEED YES WE CAN”. </h5>
      <h6>5. Martin Luther King Jr. House</h6>
      <p>
        The house is named after itsIcon Martin Luther Jr. a great inspiration
        and motivation Activist and a great leader of all time who rewrote and
        made American history. The members of this house should be mentored to
        struggle for existence of every race and must cease from racial slur.
      </p>
      <h5>he house motto is: “WE ARE THE WINNERS”. </h5>
    </div>
  );
}

export default HousePentagon;
